import React from "react";
import { User, Quote } from "lucide-react";
import { PageHero, Section } from "./_shared";
import { useMitsol } from "./MitsolLayout";

export default function Leadership() {
  const data = useMitsol();
  const list = data?.leadership || [];

  return (
    <div data-testid="mitsol-leadership">
      <PageHero
        eyebrow="From the Leadership"
        title="Leadership Message"
        sub="Voices of guidance from the chairman, principal and senior faculty of MIT (ITI) Solapur."
      />
      <Section>
        {list.length === 0 ? (
          <div className="bg-white border-2 border-dashed border-slate-200 p-16 text-center" data-testid="mitsol-leadership-empty">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#F97316]/10 text-[#F97316]">
              <Quote size={28} />
            </div>
            <div className="font-serif text-xl text-[#0F2A47] mt-5">Messages coming soon</div>
            <p className="text-sm text-slate-500 mt-2 max-w-md mx-auto">Leadership messages will appear here once published by the institute admin office.</p>
          </div>
        ) : (
          <div className="space-y-10">
            {list.map((m, i) => (
              <article
                key={m.id}
                data-testid={`mitsol-leader-${(m.designation || "member").replace(/\s+/g, "-")}`}
                className={`bg-white border border-slate-200 overflow-hidden flex flex-col md:flex-row shadow-sm ${
                  i % 2 === 1 ? "md:flex-row-reverse" : ""
                }`}
              >
                <div className="md:w-1/3 bg-gradient-to-br from-[#0F2A47] via-[#123055] to-[#08192E] flex items-center justify-center p-8 relative">
                  <div className="absolute top-4 left-4 text-[#F97316]/60"><Quote size={40} strokeWidth={1.3} /></div>
                  <div className="w-44 h-44 rounded-full overflow-hidden border-4 border-[#F97316] shadow-lg bg-white">
                    {m.photo_url ? (
                      <img src={m.photo_url} alt={m.name} className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-[#0F2A47]">
                        <User size={56} strokeWidth={1.4} />
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex-1 p-8">
                  <div className="text-[10px] tracking-[0.3em] uppercase text-[#F97316] font-bold">
                    {m.designation}
                  </div>
                  <h2 className="font-serif text-2xl md:text-3xl text-[#0F2A47] mt-1 leading-tight">{m.name || "—"}</h2>
                  {m.message_html && (
                    <div
                      className="prose prose-slate max-w-none mt-4 text-slate-700"
                      dangerouslySetInnerHTML={{ __html: m.message_html }}
                    />
                  )}
                </div>
              </article>
            ))}
          </div>
        )}
      </Section>
    </div>
  );
}
